import { z } from 'zod'
import { GameType } from '@/modules/promotion/type'
import { walletConditionSchema } from '@/common/components/WalletConditionSection'

const gameTypeSettingsSchema = z.object({
	creditRatio: z
		.number({
			required_error: 'กรุณากรอกเปอร์เซ็นต์จ่ายเครดิต',
			invalid_type_error: 'กรุณากรอกเปอร์เซ็นต์จ่ายเครดิต',
		})
		.min(0, 'เปอร์เซ็นต์จ่ายเครดิตต้องมากกว่าหรือเท่ากับ 0')
		.optional()
		.nullable(),
	maxCreditAmount: z
		.number()
		.min(0, 'เครดิตสูงสุดต้องมากกว่าหรือเท่ากับ 0')
		.optional()
		.nullable(),
})

export const commissionFormSchema = z.object({
	name: z.string().min(1, 'กรุณากรอกชื่อโปรโมชั่น'),
	isActive: z.boolean().optional(),
	creditRatio: z.record(z.nativeEnum(GameType), gameTypeSettingsSchema),
	hasExpiration: z.boolean(),
	walletCondition: walletConditionSchema.optional(),
	multiplier: z
		.number({
			required_error: 'กรุณากรอกตัวคูณ',
			invalid_type_error: 'กรุณากรอกตัวคูณ',
		})
		.min(1, 'ตัวคูณต้องมากกว่าหรือเท่ากับ 1')
		.optional()
		.nullable(),
	multiplierStartDate: z.string().optional().nullable(),
	multiplierEndDate: z.string().optional().nullable(),
})

export type CommissionFormValues = z.infer<typeof commissionFormSchema>
